var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-block"},[_c('div',{staticClass:"contents"},[_c('h2',{staticClass:"rectangle_label"},[_vm._v("活用事例")])])])}]

export { render, staticRenderFns }